import React from "react";
import "./FlipCard.css";

interface FlipCardProps {
  title: string;
  content: React.ReactNode;
  flipped?: boolean;
  delay?: string | number;
}

export default function FlipCard({ title, content, flipped, delay }: FlipCardProps) {
  return (
    <div
      className={`empresa-flip-card ${flipped ? "flipped" : ""}`}
      data-delay={delay}
    >
      <div className="empresa-flip-card-inner">
        <div className="empresa-flip-card-front">
          <h4 className="empresa-block-title">{title}</h4>
        </div>
        <div className="empresa-flip-card-back">
          <div className="empresa-block-content">{content}</div>
        </div>
      </div>
    </div>
  );
}
